import * as Yup from "yup";

export const categorySchema = Yup.object().shape({
  category_id: Yup.mixed().nullable(),
  subscription_id: Yup.mixed().nullable(),
  model_type: Yup.string().required("O tipo é obrigatório"),

  name: Yup.string().required("Nome é obrigatório"),
});
